<div *ngIf="isMobile && hamburgerClicked" class="overlay"></div>
<div *ngIf="showBanner" class="banner">
    <h1>Viewing as {{userData.FirstName}} {{userData.LastName}} - {{userRights}}, {{selectedClientName}}</h1>
</div>
<app-header [(showBanner)]="showBanner" [(selectedClientName)]="selectedClientName"
    [isMobile]="isMobile" (onHamburgerClick)="openSideNavMenu($event)" [desktop]="desktop" [memberFlyerQRCodeURL]="memberFlyerQRCodeURL">
</app-header>
<div *ngIf="isMobile && hamburgerClicked" #mobileSidenav id="mobileSidenav" [@slideInOut] class="mobile-sidenav">
    <mat-nav-list>
        <button class="close" mat-button (click)="closeSideNavMenu()">X</button>
        <div class="icon-container" [ngClass]="{'selected': selectedPage == 'pinsheet'}">
            <a [routerLink]="['/pinsheet']" (click)="closeSideNavMenu();setSelectedPage('pinsheet')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/pinsheet.svg" alt="pinsheet"/>
                <span class="icon-name">Pinsheet</span>
            </a>
        </div>
        <div [hidden]="user" class="icon-container" [ngClass]="{'selected': selectedPage == 'manage'}" 
            [ngClass]="{'disabled': isClubCarRelated && isLayoutEditable}">
            <a [routerLink]="['/manage']" (click)="closeSideNavMenu();setSelectedPage('manage')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/manageGreen.svg" alt="manage"/>
                <span class="icon-name">Manage Greens</span>
            </a>
        </div>
        <div class="icon-container" [ngClass]="{'selected': selectedPage == 'events'}"
            [hidden]="isClubCarRelated">
            <a [routerLink]="['/events']" (click)="closeSideNavMenu();setSelectedPage('events')" routerLinkActive="active">
                <img class="icon" src="../../../../assets/images/Sidenav/event.svg" alt="events"/>
                <span class="icon-name">Events</span>
            </a>
        </div>
        <div class="icon-container">
            <div class="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-216905172848"
                style="max-width:100%" data-hubspot-wrapper-cta-id="216905172848">
                <a href="https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJnWsjdw47SuiRqu1%2BBAyu6t7K3r5bnsnrGQUltXti8x3qTreiHFc4lzKvNG4jNzTdSEGaqe2VfXrH5Sv9GlrlXYyZDYFqzxu6KikzICJHJgrbyd6IzZIbP8R2HwyGtvoWffb1Kn9uY%2BDfR9R98nqSFBNT5Yy3LJZOFy9%2B6LrNgXnMYU6pUNhXlNp31rnomUpMqq4eEv3siv8rU%2Bh4MI%2BR2maaK8%2FpCYxGvchvWPr0YvCV8%2F50%2FyQAjPHYlSO%2B7&amp;webInteractiveContentId=216905172848&amp;portalId=4652692" target="_blank" rel="noopener" crossorigin="anonymous" (click)="closeSideNavMenu()">
                    <img class="icon geoez" alt="GEOEZ circle transparent V2" loading="lazy" src="https://no-cache.hubspot.com/cta/default/4652692/interactive-216905172848.png" onerror="this.style.display='none'" />
                    <span class="icon-name">GEOEZ</span>
                </a>
            </div>
        </div>
        <!-- <div class="icon-container" [ngClass]="{'selected': selectedPage == 'mobile-pinsheet'}">
            <a [href]="memberFlyerQRCodeURL" target="_blank" (click)="closeSideNavMenu();setSelectedPage('mobile-pinsheet')">
                <img class="icon " src="../../../../assets/images/Sidenav/Mobile Pinsheet.svg" alt="mobile-pinsheet"/>
                <span class="icon-name">Mobile Pinsheet</span>
            </a>
        </div> -->
        <!-- <div class="icon-container" [ngClass]="{'selected': selectedPage == 'help'}">
            <a [routerLink]="['/help']" (click)="closeSideNavMenu();setSelectedPage('help')" routerLinkActive="active">
                <img class="icon " src="../../../../assets/images/Sidenav/help.svg" alt="help"/>
                <span class="icon-name">Help</span>
            </a>
        </div> -->
        
    </mat-nav-list>
</div>
<mat-sidenav-container class="side-navigations" [ngClass]="{'imp-side-navigations': showBanner}">
    <mat-sidenav *ngIf="!isMobile" opened class="sidenav-list-container" mode="side">
        <mat-nav-list>
            <div matTooltip="Pinsheet">
                <a [routerLink]="['/pinsheet']" routerLinkActive="active"><img class="pinsheet"
                        src="../../../../assets/images/Sidenav/pinsheet.svg" alt="pinsheet " /></a>
            </div>
            <div [hidden]="user || member" matTooltip="Manage Greens" matTooltipClass="side-menu" [ngClass]="{'disabled': isClubCarRelated && isLayoutEditable}">
                <a [routerLink]="['/manage']" routerLinkActive="active"><img class="manage"
                        src="../../../../assets/images/Sidenav/manageGreen.svg" alt="manage " /></a>
            </div>
            <div matTooltip="Events" matTooltipClass="side-menu" [hidden]="isClubCarRelated">
                <a [routerLink]="['/events']" routerLinkActive="active"><img class="events"
                        src="../../../../assets/images/Sidenav/event.svg" alt="events " /></a>
            </div>
            <div matTooltip="GEOEZ" matTooltipClass="side-menu">
                <div class="hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-216905172848"
                    style="max-width:100%; display:flex; justify-content:center" data-hubspot-wrapper-cta-id="216905172848">
                    <a href="https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/redirect?encryptedPayload=AVxigLJnWsjdw47SuiRqu1%2BBAyu6t7K3r5bnsnrGQUltXti8x3qTreiHFc4lzKvNG4jNzTdSEGaqe2VfXrH5Sv9GlrlXYyZDYFqzxu6KikzICJHJgrbyd6IzZIbP8R2HwyGtvoWffb1Kn9uY%2BDfR9R98nqSFBNT5Yy3LJZOFy9%2B6LrNgXnMYU6pUNhXlNp31rnomUpMqq4eEv3siv8rU%2Bh4MI%2BR2maaK8%2FpCYxGvchvWPr0YvCV8%2F50%2FyQAjPHYlSO%2B7&amp;webInteractiveContentId=216905172848&amp;portalId=4652692" target="_blank" rel="noopener" crossorigin="anonymous">
                        <img class="geoez-menu-logo" alt="GEOEZ circle transparent V2" loading="lazy" src="https://no-cache.hubspot.com/cta/default/4652692/interactive-216905172848.png" onerror="this.style.display='none'" />
                    </a>
                </div>
            </div>
            <!-- <div matTooltip="Mobile Pinsheet" matTooltipClass="side-menu">
                <a [href]="memberFlyerQRCodeURL" target="_blank"><img class="mobile-pinsheet"
                        src="../../../../assets/images/Sidenav/Mobile Pinsheet.svg" alt="mobile-pinsheet" /></a>
            </div>
            <div matTooltip="QR Code" matTooltipClass="side-menu" *ngIf="this.clientProfileData && this.clientProfileData.MemberPassword">
                <qrcode class="qr-code-container" [cssClass]="'circular-qrcode'" id="sidenav-qr-code" 
                    [qrdata]="memberFlyerQRCodeURL" [width]="45" [margin]="0"
                    [colorDark]="'#545E69'" [errorCorrectionLevel]="'L'"></qrcode>
            </div> -->
            <!-- <div matTooltip="Help" matTooltipClass="side-menu">
                <a [routerLink]="['/help']" routerLinkActive="active"><img class="help "
                        src="../../../../assets/images/Sidenav/help.svg" alt="help " /></a>
            </div>
            <div [hidden]="true">
                <a [routerLink]="['/client-info']" routerLinkActive="active"><img class="client_info "
                        src="../../../../assets/images/Sidenav/help.svg" alt="client-info " /></a>
            </div>
            <div [hidden]="true">
                <a [routerLink]="['/user-info']" routerLinkActive="active"><img class="user_info "
                        src="../../../../assets/images/Sidenav/help.svg" alt="user-info " /></a>
            </div> -->
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content id="main-content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
<!--<app-footer></app-footer>-->